import type { DiagramSeriesOption } from '../types/DiagramSeries.types';

/** "RPM (1/min)" — the unit belongs to the label wherever a series is named in the UI. */
export function formatDiagramSeriesLabel(series: DiagramSeriesOption): string {
  return series.unit ? `${series.label} (${series.unit})` : series.label;
}
